import { useModuleContext } from "./ModuleContext"
import { calculateModuleScore } from "./utils"
import React, { useState } from "react"
import useNotifications from "../../notifications/useNotifications"
import { FirebaseContext } from "../../Firebase"

/**
 * Hook for performing combination actions, UI updates coupled with API calls
 * @returns {}
 */
export const useInteractiveActions = (firebase) => {
  const { dispatch, moduleUI, moduleState, moduleId, programId, loadUserModuleRecord, mode } = useModuleContext()
  const { handleModuleCompletion, goToNextSlide, resetModuleUI } = moduleUI
  const [isSubmitting, setIsSubmitting] = useState(false)
  const [isSaving, setIsSaving] = useState(false)
  const { handleModuleCompletionNotification, setIsDisabled, isDisabled } = useNotifications(firebase)

  const recordResponse = (response, coordinates) => {
    const { slideIndex, componentIndex, sectionIndex } = coordinates

    dispatch({
      type: "RECORD_RESPONSE",
      slideIndex,
      componentIndex,
      sectionIndex,
      payload: response,
    })
  }

  const submitModule = async () => {
    const score = calculateModuleScore(moduleState)

    try {
      setIsSubmitting(true)
      await firebase.updateUserModuleById({
        moduleId: moduleId,
        moduleJson: moduleState,
      })

      await firebase.updateUserModuleStatus({
        moduleId: moduleId,
        status: "completed",
        score: score,
      })

      if (score >= 70) {
        // send notification if they passed
        handleModuleCompletionNotification(moduleState.title, moduleId)
      }
    } catch (error) {
      console.error("Error updating module status:", error)
    } finally {
      handleModuleCompletion()
      setIsSubmitting(false)
    }
  }

  const goToNextSlideAndSaveProgress = async () => {
    goToNextSlide()

    if (mode === "STUDENT") {
      await firebase.updateUserModuleById({
        moduleId: moduleId,
        moduleJson: moduleState,
      })
    }
  }

  const handleManualSaveAndAlert = async () => {
    try {
      setIsSaving(true)
      await firebase.updateUserModuleById({
        moduleId: moduleId,
        moduleJson: moduleState,
      })
      // alert("Saved successfully!")
    } catch (error) {
      console.error("Error updating module status:", error)
    } finally {
      setIsSaving(false)
    }
  }

  const restartModule = async () => {
    try {
      setIsSubmitting(true)
      const res = await firebase.restartUserModule(moduleId)

      dispatch({
        type: "LOAD_FULL_MODULE",
        payload: res.data.res[0].module_json,
      })
      resetModuleUI()
    } catch (error) {
      console.error("Error restarting module:", error)
    } finally {
      setIsSubmitting(false)
    }
  }

  return {
    recordResponse,
    submitModule,
    goToNextSlideAndSaveProgress,
    handleManualSaveAndAlert,
    restartModule,
    isSubmitting,
    isSaving,
  }
}
